module.exports = __webpack_public_path__ + "img/mobradio.0d3fb007.png";